import jwtDecode from 'jwt-decode';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import { apiClient } from './../../api/ApiClient';

@Module({ namespaced: true })
export default class extends VuexModule {

  public jwt: string = '';
  public roles: string[] = [];

  public get payload() {
    return jwtDecode(this.jwt);
  }

  @Mutation
  public async setJwt(jwt: string) {
    this.jwt = jwt;
  }

  @Mutation
  public async setRoles(roles: string[]) {
    this.roles = roles;
  }

  @Action({ commit: 'setJwt' })
  public async login(loginForm: any) {
    const { data } = await apiClient.login(loginForm);
    return data.token;
  }

  @Action({ commit: 'setRoles' })
  public async loadRoles() {
    const { data } = await apiClient.account();
    return data.roles;
  }

}

